import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action'
import type { Blog } from '../Blog'

/**
 * Input arguments for transcribing blog videos mutation
 */
@InputType()
export class TranscribeBlogVideosArgs extends ActionArgs {
  @Field()
  blogId!: string
}

export interface ITranscribeBlogVideos extends IAction<Blog, TranscribeBlogVideosArgs> {}
